import { css } from "@emotion/react";

export const button = css`
  flex-shrink: 0;
`;
